import React from "react";
import {removeDuplicatesInArray} from "./utils";
import styled from "styled-components";

const Indicators = ({countUsers, strategy, axis, projects, stakes}) => {
    const pilots = removeDuplicatesInArray(projects.map(p => p.pilot))
    const actions = projects.map(p => p.actions).flat()
    const objectives = projects.map(p => p.okrs).flat()
    const krs = objectives.map(o => o.keyResults).flat()

    const doneProjects = projects.filter(p => p.advancement === 100)
    const doneActions = actions.filter(a => a.advancement === 100)
    const lateProjects = projects.filter((p) =>
        p.endDate &&
        new Date(p.endDate) <= new Date() &&
        p.advancement < 100)
    const runningProjects = projects.filter(p => p.advancement < 100);
    const lateActions = actions.filter((a) =>
        !!a.deadline &&
        new Date(a.deadline) <= new Date() &&
        a.advancement < 100)

    const projetPerPilots = () => {
        return (projects.length / pilots.length).toFixed(2)
    }
    const cropText = (text, maxlength) => {
        return text.length > maxlength ? (text.substring(0,maxlength) + "[...]") : text
    }


    return (
        <>
            <IndicatorSection>
                <div className="col1">
                    <div className="block">
                        <p className="enjoy-block-title">Chiffres clefs</p>
                        <div className="numbers-inner">
                            <div className="indicators">
                                <div className="indicator-card">{axis.length} {axis.length > 1 ? "Axes" : "Axe"}</div>
                                <div className="indicator-card">{stakes.length} {stakes.length > 1 ? "Enjeux" : "Enjeu"}</div>
                                <div className="indicator-card">{projects.length} {projects.length > 1 ? "Projets" : "Projet"} </div>
                                <div className="indicator-card">{actions.length} {actions.length > 1 ? "Actions" : "Action"}</div>
                                <div className="indicator-card">{objectives.length} {objectives.length > 1 ? "Objectifs" : "Objectif"}</div>
                                <div className="indicator-card">{krs.length} {krs.length > 1 ? "Indicateurs" : "Indicateur"}</div>
                                <div className="indicator-card" style={{background: "#4BB472FF"}}>
                                    {doneProjects.length} { doneProjects.length > 1 ? "Projets terminés" : "Projet terminé"}
                                </div>
                                <div className="indicator-card" style={{background: "#FFB400"}}>
                                    {runningProjects.length} {runningProjects.length > 1 ? "Projets" : "Projet"}  en cours
                                </div>
                                <div className="indicator-card" style={{background: projetPerPilots() > 3 ? "#FFB400" : "#4BB472FF"}}>
                                    {projetPerPilots()} {projetPerPilots() > 1 ? "Projets" : "Projet"} / Pilote
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"block"}>
                        <p className="enjoy-block-title"> {strategy.name} </p>
                        <div className="values">
                            <div className="values-card" style={{background: "#4BB472FF"}}>
                                <p className="values-card-title">Nos valeurs</p>
                                <p>{strategy.success ? strategy.success.length > 0 ? cropText(strategy.success, 300) : "à compléter" : "à compléter"}</p>
                            </div>
                            <div className="values-card">
                                <p className="values-card-title">Notre mission</p>
                                <p>{strategy.mission ? strategy.mission.length > 0 ? cropText(strategy.mission, 300) : "à compléter" : "à compléter"}</p>
                            </div>
                            <div className="values-card" style={{background: "#3394F6"}}>
                                <p className="values-card-title">Notre vision</p>
                                <p>{strategy.vision ? strategy.vision.length > 0 ? cropText(strategy.vision, 300) : "à compléter" : "à compléter"}</p>
                            </div>
                            <div className="values-card" style={{background: "#4909AA"}}>
                                <p className="values-card-title">Notre ambition</p>
                                <p>{strategy.goal ? strategy.goal.length > 0 ? cropText(strategy.goal, 300) : "à compléter" : "à compléter"}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </IndicatorSection>
        </>
    )
}

export default Indicators

const IndicatorSection = styled.section`
    max-width: 95%;
    margin: 0 auto;

    .indicators-section-title {
        display: flex;
        justify-content: space-between;
        max-width: 80%;
        margin: auto;
    }

    .indicators {
        display: grid;
        grid-gap: 0.5rem;
        grid-template-columns: repeat(3, minmax(100px, 1fr));
        grid-template-rows: repeat(3, minmax(100px, 1fr));

        @media screen and (min-width: 1100px) {
            grid-template-columns: repeat(3, minmax(100px, 100px));
            grid-template-rows: repeat(3, minmax(100px, 100px));
        }
        @media print {
            grid-template-columns: repeat(3, minmax(80px, 80px));
            grid-template-rows: repeat(3, minmax(80px, 80px));
        }
    }

    .indicator-card {
        display: flex;
        padding: 0.5rem;
        background: #4909aa;
        border-radius: 10px;
        color: white;
        text-align: center;
        font-size: 14px;
        font-weight: bolder;
        justify-content: center;
        align-items: center;
        @media print {
            font-size: 14px;
        }
    }

    .block {
        display: flex;
        flex-direction: column;
        @media print {
            page-break-inside: avoid;
        }
    }

    .numbers-inner {
        display: grid;
        gap: 0.8rem;

        @media print {
            grid-template-columns: repeat(1, minmax(30%, 1fr));
            gap: 0.8rem;
            align-self: center;
        }
        @media screen and (min-width: 900px){
      grid-template-columns: repeat(2, minmax(30%, 1fr));
      gap: 0.8rem;
    }

    @media screen and (min-width: 1100px){
      align-self: center;
    }
  }

  .col1{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
    
    @media screen and (min-width: 900px){
      display: grid;
      grid-template-columns: 35% 65%;
    }
    
    @media print{
      display: grid;
      grid-template-columns: 30% 65%;
    }
  }

  .values{
    display: grid;
    grid-gap: 0.5rem;
    justify-content: center;
    grid-template-columns: repeat(1, minmax(150px, 1fr));
    grid-template-rows: repeat(4, minmax(150px, 1fr));
    @media screen and (min-width: 700px){
      grid-template-columns: repeat(2, minmax(100px, 1fr));
      grid-template-rows: repeat(2, minmax(100px, 200px));
    }
    @media print{
      grid-template-columns: repeat(2, minmax(200px, 200px));
      grid-template-rows: repeat(2, minmax(50px, 125px));
    }
  }

  .values-card{
    padding: 0.5rem;
    border-radius: 10px;
    text-align: center;
    background: #FFB400;
  }

  .values-card .values-card-title{
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 0.5rem;
    
    @media print{
      font-size: 16px;
    }
  }

  .values-card p{
    color: white;
    font-size: 12px;
    text-overflow: ellipsis;
    font-weight: bold;
    text-align: left;

    @media print{
      font-size: 9px;
    }
  }
    
`